import { TMutableWidgetsData, TMutableWidgetsOption, TConfiguration } from './store';
import { TButtonData } from './widget/data';
import { TPayloadWidget } from './widget/widget';

export type TPage = {
    widgets: TPayloadWidget<TMutableWidgetsData & TButtonData, TMutableWidgetsOption>[];
    id: string;
    themeName?: string;
    configuration?: TConfiguration;
};
